import { OPTIONAL_LANG } from 'tradera-apps/tradera/helpers/optional-lang';

export const razorRoutes = [
    '/Shopping/CartOrderConfirmation',
    '/Shopping/Checkout/SelectPayment',
    '/Shopping/Summary/Index',
    '/shopping/cartcheckout',
    '/shopping/open-swish/:paymentAttemptId',
    '/messaging/thread/:threadId',
    '/messaging/threads/:threadId',
    '/messaging',
    '/my/order/:orderId',
    '/my/overview-buyer',
    '/my/overview-seller',
    '/my/overview',
    '/my/saved-searches',
    '/my/wish-list',
    '/my/notifications',
    '/my/picklist/print',
    '/my/picklist',
    '/my/Invoices',
    '/my/Invoices/Payment/:paymentId',
    '/my/Invoices/PaymentConfirmation',
    '/my/Invoices/UnInvoicedFees',
    '/ma/endless-recommendation',
    '/my/saved-searches',
    '/my/profile/changed-password',
    '/my/Payments',
    '/my/shipping/checkout',
    '/my/shipping/checkout/pay',
    '/my/shipping/confirmation/:shipmentCheckoutId',
    '/my/shipping/traceable',
    '/my/shipping',
    '/register/swedish-company',
    '/register/foreign-company',
    '/register/foreign-private',
    '/register',
    '/login/changepassword',
    '/login/accountlockedanonymous',
    '/login/entercellnumber',
    '/login/forgotpassword',
    '/login/forgotusercredentials',
    '/login/resetemail',
    '/login/verifybankId',
    '/login/verifycellnumber',
    '/login/verifysmscode',
    '/login',
    '/resolution/INR/:itemId/Submission',
    '/resolution/UPI/:itemId',
    '/resolution/FeedbackRemovalConfirmation/:feedbackRemovalRequestId/ConfirmationDetails'
].map(path => ({
    path: `${OPTIONAL_LANG}${path}`,
    exact: true
}));
